/**
 * A placeholder token: `{{`, anything but a brace, `}}`.
 *
 * Found by shape alone. Whether what sits between the braces is a usable
 * expression is `parsePlaceholderExpression`'s decision, so the marker parser
 * and the filler always agree on where a token starts and ends — including for
 * a token that turns out to be a typo and stays literal.
 *
 * A source string rather than a RegExp so the marker grammar can embed it: a
 * marker's text may contain whole tokens, which is what lets
 * `{b|{{ user.firstName }}}` bold a filled-in value instead of ending the
 * marker at the token's first `}`.
 */
export const PLACEHOLDER_TOKEN_PATTERN = String.raw`\{\{[^{}]*\}\}`;
